export const ServiceType = {
  AVITO: 'AVITO',
  ASTRA_LAB: 'ASTRA_LAB',
  GOOGLE: 'GOOGLE',
  IVI: 'IVI',
  KINOPOISK: 'KINOPOISK',
  MEDIAPLATFORM: 'MEDIAPLATFORM',
  METRICAPRO: 'METRICAPRO',
  MTS_DSP: 'MTS_DSP',
  MTS_SMS: 'MTS_SMS',
  MYTARGET: 'MYTARGET',
  RUTUBE: 'RUTUBE',
  TIKTOK: 'TIKTOK',
  TJ: 'TJ',
  PROMOPAGES: 'PROMOPAGES',
  TELEGRAM: 'TELEGRAM',
  VKADS: 'VKADS',
  VKMARKET: 'VKMARKET',
  VKONTAKTE: 'VKONTAKTE',
  YANDEX: 'YANDEX',
  YANDEXBUSINESS: 'YANDEXBUSINESS',
  VKADBLOGGER: 'VKADBLOGGER',
  ROXOT: 'ROXOT',
  RBK: 'RBK',
  SOLOWAY: 'SOLOWAY',
  ONETARGET: 'ONETARGET',
  HYBRID: 'HYBRID',
};

export const ServiceName = {
  [ServiceType.AVITO]: 'Авито',
  [ServiceType.GOOGLE]: 'Google Ads',
  [ServiceType.MEDIAPLATFORM]: 'Медиаплощадки',
  [ServiceType.METRICAPRO]: 'Метрика Про',
  [ServiceType.TIKTOK]: 'TikTok',
  [ServiceType.MYTARGET]: 'myTarget',
  [ServiceType.PROMOPAGES]: 'Яндекс ПромоСтраница',
  [ServiceType.TELEGRAM]: 'Telegram',
  [ServiceType.VKADS]: 'VK Реклама',
  [ServiceType.VKMARKET]: 'VK Маркет',
  [ServiceType.VKONTAKTE]: 'ВКонтакте',
  [ServiceType.YANDEX]: 'Яндекс Директ',
  [ServiceType.YANDEXBUSINESS]: 'Яндекс Бизнес',
  [ServiceType.VKADBLOGGER]: 'VK AdBlogger',
  [ServiceType.ROXOT]: 'Roxot',
  [ServiceType.RBK]: 'RBK',
  [ServiceType.SOLOWAY]: 'Soloway',
  [ServiceType.ONETARGET]: 'Onetarget',
  [ServiceType.HYBRID]: 'Hybrid',
  [ServiceType.AVITO]: 'Авито',
  [ServiceType.ASTRA_LAB]: 'Astralab',
  [ServiceType.GOOGLE]: 'Google Ads',
  [ServiceType.IVI]: 'Иви',
  [ServiceType.KINOPOISK]: 'Кинопоиск',
  [ServiceType.MEDIAPLATFORM]: 'Медиаплощадки',
  [ServiceType.METRICAPRO]: 'Метрика Про',
  [ServiceType.MTS_DSP]: 'МТС DSP',
  [ServiceType.MTS_SMS]: 'МТС SMS',
  [ServiceType.MYTARGET]: 'myTarget',
  [ServiceType.PROMOPAGES]: 'Яндекс ПромоСтраница',
  [ServiceType.RUTUBE]: 'RuTube',
  [ServiceType.TIKTOK]: 'TikTok',
  [ServiceType.TJ]: 'tj',
  [ServiceType.TELEGRAM]: 'Telegram',
  [ServiceType.VKADS]: 'VK Реклама',
  [ServiceType.VKMARKET]: 'VK Маркет',
  [ServiceType.VKONTAKTE]: 'ВКонтакте',
  [ServiceType.YANDEX]: 'Яндекс Директ',
  [ServiceType.YANDEXBUSINESS]: 'Яндекс Бизнес',
  [ServiceType.VKADBLOGGER]: 'VK AdBlogger',
};

const ServiceColors = {
  [ServiceType.MYTARGET]: '#fc2c38',
  [ServiceType.YANDEX]: '#fc0',
  [ServiceType.PROMOPAGES]: '#8B00FF',
  [ServiceType.YANDEXBUSINESS]: '#C9CBCF',
  [ServiceType.VKONTAKTE]: '#5181b8',
  [ServiceType.VKADS]: '#00D9ED',
  [ServiceType.VKMARKET]: '#FF6384',
  [ServiceType.GOOGLE]: '#34a853',
  [ServiceType.TIKTOK]: '#000',
  [ServiceType.TELEGRAM]: '#229ED9',
  [ServiceType.AVITO]: '#4BC0C0',
  [ServiceType.MEDIAPLATFORM]: '#9966FF',
  [ServiceType.METRICAPRO]: '#FFCE56',
  [ServiceType.VKADBLOGGER]: '#74CE46',
  [ServiceType.ROXOT]: '#E85D04',
  [ServiceType.RBK]: '#C41E3A',
  [ServiceType.SOLOWAY]: '#1B6CA8',
  [ServiceType.ONETARGET]: '#FF6B35',
  [ServiceType.HYBRID]: '#6C5CE7',
  [ServiceType.MTS_SMS]: '#E30611',
  [ServiceType.MTS_DSP]: '#FF4D6D',
  [ServiceType.ASTRA_LAB]: '#7B61FF',
  [ServiceType.KINOPOISK]: '#FF5500',
  [ServiceType.IVI]: '#F30745',
  [ServiceType.RUTUBE]: '#100943',
  [ServiceType.TJ]: '#36B37E',
};

export const REMOVED_PLATFORMS = ['vkontakte', 'mytarget'];

export const isRemovedPlatform = (slug) => {
  if (!slug) return false;
  return REMOVED_PLATFORMS.includes(String(slug).toLowerCase());
};

export const filterRemovedPlatforms = (list) => {
  if (!Array.isArray(list)) return list || [];
  return list.filter((item) => {
    const slug =
      typeof item === 'string'
        ? item
        : item?.slug || item?.service || item?.value || item?.label || item?.key;
    return !isRemovedPlatform(slug);
  });
};

export const getServiceName = (service) => {
  if (!service) return '';
  const key = String(service).toUpperCase();
  return ServiceName[key] || service;
};

export const getServiceColor = (service) => {
  if (!service) return '#2e89ff';
  const formattedService = service.toUpperCase();

  return ServiceColors[formattedService] || '#2e89ff';
};
